import classNames from 'classnames';
import { memo, FC } from 'react';

import { Skeleton } from '@gem/ui-kit';

import styles from './CirclePlaceholder.styles.m.css';

interface ICirclePlaceholderProps {
  isAnimated: boolean;
  className?: string;
  size: number;
}

export const CirclePlaceholder: FC<ICirclePlaceholderProps> = memo((props) => {
  const { isAnimated, className, size } = props;

  return (
    <Skeleton
      borderRadius="50%"
      isAnimated={isAnimated}
      width={`${size}px`}
      height={`${size}px`}
      className={classNames(styles.container, className)}
    />
  );
});
